import { render, staticRenderFns } from "./stock-report.vue?vue&type=template&id=287603a6&scoped=true"
import script from "./stock-report.vue?vue&type=script&lang=js"
export * from "./stock-report.vue?vue&type=script&lang=js"
import style0 from "./stock-report.vue?vue&type=style&index=0&id=287603a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287603a6",
  null
  
)

export default component.exports